/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   8/7/20 7:17 PM
 */
import React from "react";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import AppRoutes from "./AppRoutes";
import CssBaseline from '@mui/material/CssBaseline';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {useMediaQuery} from "@mui/material";
import getTheme from "./context/theme";
import getClient from "./context/urql";
import {Provider as GraphQLProvider} from "urql";
import {useDispatch, useSelector} from "react-redux";
import {State} from "./state/store";
import {locale} from "./dates-helper";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.min.css';

export default function App() {

	const user = useSelector((s:State) => s.user);
	const theme = useSelector((s:State) => s.preferences.theme);
	const dispatch = useDispatch();

	const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
	const muiTheme = React.useMemo(
		() => getTheme(theme || (prefersDarkMode ? "dark" : "light")),
		[theme, prefersDarkMode]
	);

	const client = React.useMemo(() => getClient({ user, dispatch }), [dispatch, user]);

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
			<GraphQLProvider value={client}>
				<StyledEngineProvider injectFirst>
					<ThemeProvider theme={muiTheme}>
						<CssBaseline />
						<AppRoutes />
						<ToastContainer
							position={"bottom-right"}
							newestOnTop
							theme={muiTheme.palette.mode}
						/>
					</ThemeProvider>
				</StyledEngineProvider>
			</GraphQLProvider>
		</LocalizationProvider>
	);
}
